"use client";
import { jsx as a, jsxs as h } from "react/jsx-runtime";
import { createContext as I, useContext as i } from "react";
import { classNames as d } from "../../utilities/index.js";
import b from "../Image/index.js";
import p from "../Icon/index.js";
import "./index.css.js";
const c = I(null), s = ({ variant: t, className: e, children: n, ...r }) => {
  const o = d({
    "sash-IconCard bg-white h-full flex flex-col items-center text-center border border-gray-15 relative transition-all [&:has(>a)]:hover:shadow-lg": !0,
    "justify-center p-6 md:px-8 md:py-10 xl:py-16 [&:has(>a)]:hover:bg-primary": !t,
    "sash-IconCard--boxed justify-start py-8 px-7 [&>ul]:mt-4": t === "boxed-icon-with-text",
    [e]: e
  });
  return /* @__PURE__ */ a(c.Provider, { value: t, children: /* @__PURE__ */ a(
    "div",
    {
      className: o,
      ...r,
      children: n
    }
  ) });
}, l = ({ src: t, className: e, ...n }) => t ? /* @__PURE__ */ a(
  b,
  {
    src: t,
    className: `sash-CardImage mx-auto mb-5 block h-20 w-20 ${e || ""}`,
    objectFit: "contain",
    alt: "",
    ...n
  }
) : null, m = ({ name: t, className: e, ...n }) => {
  const r = i(c), o = d({
    "sash-CardIcon mx-auto flex items-center justify-center": !0,
    "bg-primary rounded-full h-10 w-10 border border-black mb-4": !r,
    "text-7xl mb-5 w-20 h-20": r === "boxed-icon-with-text",
    [e]: e
  });
  return t ? /* @__PURE__ */ a(
    p,
    {
      name: t,
      className: o,
      size: r ? 64 : 24,
      ...n
    }
  ) : null;
}, x = ({ content: t, className: e, ...n }) => {
  const r = i(c), o = d({
    "sash-CardHeading font-semibold text-base": !0,
    "md:text-lg xl:text-26px": !r,
    "md:text-xl": r === "boxed-icon-with-text",
    [e]: e
  });
  return t ? /* @__PURE__ */ a(
    "div",
    {
      className: o,
      dangerouslySetInnerHTML: { __html: t },
      ...n
    }
  ) : null;
}, u = ({ content: t, className: e, children: n, ...r }) => {
  const o = i(c), C = d({
    "sash-CardContent": !0,
    "mt-4": !o,
    "mt-2 text-sm": o === "boxed-icon-with-text",
    [e]: e
  });
  return /* @__PURE__ */ h(
    "div",
    {
      className: C,
      ...r,
      children: [
        t && /* @__PURE__ */ a("div", { dangerouslySetInnerHTML: { __html: t } }),
        n
      ]
    }
  );
};
s.Image = l;
s.Icon = m;
s.Heading = x;
s.Content = u;
l.displayName = "IconCard.Image";
m.displayName = "IconCard.Icon";
x.displayName = "IconCard.Heading";
u.displayName = "IconCard.Content";
const j = s;
export {
  j as default
};
